import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Button, Icon} from 'semantic-ui-react';
import {FormattedMessage} from 'react-intl';

import * as ResourceApi from 'api/resources';
import ResourceFormProxy from 'classes/ResourceFormProxy';
import {deletedResourceAction} from "../resources/actions";
import {extractResourceIdsWithPath, isFunction} from "../utils/DBUtils";
import {startDeleteAction} from "../pages/DeleteConfirmation/actions";

const DeleteResourceButton = (props) =>  {

    let result = null
    console.log(`props`, props)

    try  {
        result = 
            <Button className="db-delete-button"
                onClick={() => props.deleteConfirmation(
                    props.deletableType,
                    props.formProxy.currentResource,
                    props.formProxy.baseResource["MASTER"],
                    props.formProxy.currentBaseResource,
                    props.formProxy.resourcePath,
                    props.formProxy.fieldPath)
                }>
                <Icon name="remove circle"/> <FormattedMessage id={`${ props.deletableType ? 'delete.button.' + props.deletableType.toLowerCase() : ''} `}
                                                        defaultMessage={props.deletableType}/>
            </Button> 
    } catch (e) {
        console.log(e.message)
    }
    


    return (result);
}

DeleteResourceButton.propTypes = {
    formProxy: PropTypes.instanceOf(ResourceFormProxy),
    section: PropTypes.object,
    deletableType: PropTypes.oneOf(Object.keys(ResourceApi.Types))
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    deleteConfirmation: (type, resource, masterResource, rootResource, resourcePath, fieldPath) => {
        let resourceIds = extractResourceIdsWithPath(masterResource, rootResource, resourcePath);
        dispatch(startDeleteAction(
            resource,
            resource.resourceId,
            resourceIds,
            isFunction(ownProps.section.deleteAdditionalArgs) ? ownProps.section.deleteAdditionalArgs(ownProps.formProxy) : {},
            // After successful delete pass on delete action to resource reducer to delete object from state
            [deletedResourceAction(
                resource,
                rootResource,
                resourceIds,
                resourcePath,
                fieldPath
            )]
        ))
    }
});

const ConnectedDeleteResourceButton = connect(null, mapDispatchToProps)(DeleteResourceButton);

export default ConnectedDeleteResourceButton;



// WEBPACK FOOTER //
// ./public/hoc/DeleteResourceButton.jsx